function ActorConfigurationPage() {
    /**
     *
     */
    ActorConfigurationPage.prototype.initialize = function (console, device, index) {
        this.id = "actorConfiguration";
        this.console = console;
        this.device = device;
        this.actorIndex = index;

        if (index >= 0) {
            this.actor = device.actors[index]; // TODO Clone
        }

        return this;
    };

    /**
     *
     */
    ActorConfigurationPage.prototype.actorTypeChanged = function () {
        this.actor = Actor.create(this.device, this.device.getActorType(this.plugin));
    };

    /**
     *
     */
    ActorConfigurationPage.prototype.show = function () {
        var deferred = $.Deferred();

        this.console.deviceConfigurationScope = 1;

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    ActorConfigurationPage.prototype.createActor = function () {
        this.device.actors.push(this.actor);
        this.console.popPage();
    };

    /**
     *
     */
    ActorConfigurationPage.prototype.updateActor = function () {
        this.device.actors[this.actorIndex] = this.actor;

        this.console.popPage();
    };

    /**
     *
     */
    ActorConfigurationPage.prototype.leave = function () {
    };
}
